import styles from './Spinner.module.css'


const logoUrl = `${import.meta.env.BASE_URL}icons/about.svg`

type SpinnerProps = {
  label?: string
  size?: 'sm' | 'md'
}

export default function Spinner({ label = 'Loading', size = 'md' }: SpinnerProps) {
  return (
    <span className={`${styles.root} ${size === 'sm' ? styles.sm : ''}`}>
      <span className={styles.ring} data-motion="essential" aria-hidden="true" />
      {size === 'md' && (
        <img className={styles.logo} src={logoUrl} alt="" aria-hidden="true" />
      )}
      {label && <span className="visually-hidden">{label}</span>}
    </span>
  )
}
